<template>
  <div v-wechat-title="$route.meta.title" style="background: #fff">
    <div class="dateTime">
        <van-row>
          <van-col span="2"><img class="back" @click="$router.go(-1)" src="../assets/pingzi/back.png" alt="" /></van-col>
          <van-col span="11">
            <input type="text" readonly :value="startTime" @click="showStartTime = true" placeholder="选择开始时间" />
            <van-calendar v-model="showStartTime" @confirm="onConfirmStartTime" @close="closeTimePop" :show-confirm="false" :min-date="minStartDate" :max-date="maxStartDate" />
          </van-col>
          <van-col span="11">
            <input type="text" readonly :value="endTime" @click="showEndTime = true" placeholder="选择结束时间" />
            <van-calendar v-model="showEndTime" @confirm="onConfirmEndTime" @close="closeTimePop" :show-confirm="false" :min-date="minEndDate" :max-date="maxEndDate" />
          </van-col>
        </van-row>
    </div>
    <div style="height:30px"></div>
    <div class="main">
      <template v-if="list.length>0">
        <div class="list" v-for="(item, index) of list" :index="index" :item="item" :key="index">
            <van-row class="rowlist">
              <van-col span="24"><span>纠错时间：</span>{{item.CreateTime}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="24"><span>产品名称：</span>{{item.ProductName}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="24"><span>产品型号：</span>{{item.ModelName}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="12"><span>产品品牌：</span>{{item.BrandName}}</van-col>
              <van-col span="12"><span>车型ID：</span>{{item.VehicleTypeId}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="24"><span>vin码：</span>{{item.Vin}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="24"><span>问题描述：</span>{{item.Content}}</van-col>
            </van-row>
            <van-row class="rowlist">
              <van-col span="24"><span>处理结果：</span>{{item.HandlerType}}</van-col>
            </van-row>
            <div class="fr"><van-button type="primary" size="mini" class="jiucuo" @click="toErrorCorrection(item)">纠错详情</van-button></div>
            <div style="clear:both"></div>
          </div>
      </template>
      <div class="noData" v-else>暂无数据</div>
    </div>
    
  </div>
  
</template>


<script>
import Vue from "vue";
import { List, Toast } from "vant";
import util from "../utils/util";
import api from "../services/api";
import $ from "../utils/axiosp";

import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Col,
  Row,
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
  Uploader
} from "vant";
import IndexStore from "../store/Index";

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Uploader);

export default {
  name: "errorCorrection",
  components: {  },
  computed: {
    
  },
  data() {
    return {
      startTime:'',
      showStartTime:false,
      endTime:'',
      showEndTime:false,
      minStartDate: new Date(2020, 1, 1),
      maxStartDate: new Date(),
      minEndDate: new Date(2020, 1, 1),
      maxEndDate: new Date(),
      list: []
    };
  },
  async created() {
    
  },
  async mounted() {
    this.getListData();
    console.log(this.minDate);
  },
  methods: {
    toErrorCorrection(data){
      console.log(data);
      this.$router.push({
        path:'/errorCorrection',  
        query:{
          ProductTitle:data.ProductName,//产品名称
          ProductBrandName:data.BrandName,//品牌名称
          ManuProductCode:data.ModelName,//产品型号
          VehicleTypeId:data.VehicleTypeId,//车型ID
          vinCode:data.Vin,//vin码
          ProductId:data.ProductId,//产品ID
          BrandId:data.BrandId,//品牌ID
          errTime:data.CreateTime,
          Status:data.Status,
          type:'view',
          imgList:data.ImageURL,
          HandlerType:data.HandlerType,
          HandDetails:data.HandDetails,
          remark:data.Content
        }
      })
    },
    formatDate(date) {
      console.log(date.getYear);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirmStartTime(startTime) {
      this.showStartTime = false;
      this.startTime = this.formatDate(startTime);
      this.minEndDate = new Date(this.startTime)
      
    },
    onConfirmEndTime(endTime) {
      this.showEndTime = false;
      this.endTime = this.formatDate(endTime);
      this.maxStartDate = new Date(this.endTime)
    },
    closeTimePop(){
      if(this.startTime!='' && this.endTime!=''){
        // window.scrollTo(0,0);
        this.getListData()
      }
    },
    getListData(){
      this.$parent.Loading(true);
      $.reqPost("RobotErrorCorrection/GetRobotErrorCorrection", {
          StartTime:this.startTime,
          EndTime:this.endTime,
        }).then(res => {
          this.list = [];
          let data = res.Data;
          data.forEach((item,index)=>{
            item.CreateTime = item.CreateTime.replace(/T/, " ")
            this.list.push(item)
          })
          this.$parent.Loading(false);
        }).catch((err) => {
          Toast(err || "系统繁忙，请您稍后再试。");
          this.$parent.Loading(false);
        });
      
    }
  },
};
</script>

<style lang="scss" scoped>
  .main{
    font-size: 0.24rem;
    padding:10px 10px 0 10px;
    .rowlist{
      padding:4px 0
    }
    .list{
      border-bottom:1px solid #eee;
      position: relative;
      padding:10px 0;
      .fr{
        text-align: right;
      }
    }
    .van-row span{
      color: #333;
      font-weight: bold
    }
  }
  .btns{
    display:flex;
    justify-content: center;
    position: fixed;
    bottom:20px;
    left:0;
    width:100%;
    .van-button{
      margin:0 10px
    }
  }
  .dateTime{
    font-size: 0.24rem;
    padding:10px;
    border-bottom: 1px solid #eee;
    position: fixed;
    top:0;
    left:0;
    width:100%;
    background: #fff;
    box-sizing: border-box;
    z-index: 1;
    input{
      width: 98%;
      padding:5px;
      box-sizing: border-box;
      border:1px solid #ccc;
      border-radius: 3px;
      background: url(../assets/icon/date.png) no-repeat right center;
      background-size: auto 70% 
    }
  }
  .noData{
    text-align: center;
    color: #999;
    padding:20px 10px;
    font-size: 0.28rem
  }
  .back{
      width:0.4rem;
      margin-top: 0.05rem
  }
</style>